export default {"src":"/_next/static/media/dot-grid.b16cacf7.svg","height":163,"width":90,"blurWidth":0,"blurHeight":0};